import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import moment from "moment";
import EngagementService from "../../../Services/Engagement.service";
import useService from "../../Hooks/useService";
import KeyEngagementAdvisorScore from "./KeyEngagementAdvisorScore";
import Busy from "../../../../components/shared/busy";
import FAIcon from "../../UI/FAIcon/FAIcon";
import ProgressBar from "../../UI/ProgressBar/ProgressBar";
import BootstrapColorService from "../../../Services/Shared/BootstrapColor.service";
import useHasPermission from "../../Hooks/useHasPermission";
const PAGE_SIZE = 10;
const getLastKeyEngagementDateFilter = (daysAgo) => {
    return moment().add(-daysAgo, "days").format("YYYY-MM-DDTHH:mm:ss\\Z");
};
const KeyEngagementTeam = (props) => {
    const [people, loadPeople] = useService(EngagementService.getKeyEngagementPerformance);
    const [isExpanded, setIsExpanded] = React.useState(false);
    const [sortField, setSortField] = React.useState("name");
    const [order, setOrder] = React.useState("asc");
    const [pageIndex, setPageIndex] = React.useState(0);
    const hasNextPage = React.useMemo(() => {
        return people.data ? people.data.length > PAGE_SIZE : false;
    }, [people]);
    const hasPrevPage = React.useMemo(() => {
        return pageIndex > 0;
    }, [pageIndex]);
    const nextPage = () => {
        setPageIndex((prevIndex) => prevIndex + 1);
    };
    const prevPage = () => {
        setPageIndex((prevIndex) => prevIndex - 1);
    };
    const canSeeAllKeyEngagements = useHasPermission("CAN_SEE_ALL_KE_PERFORMANCE");
    React.useEffect(() => {
        loadPeople({
            lastKeyEngagementMaxAgeDaysAgo: props.lastKeyEngagementMaxDaysAgo,
            teamIds: [props.teamEngagement.teamId],
            registrationTermIds: props.registrationTerms.map((term) => term.id),
            offset: PAGE_SIZE * pageIndex,
            max: PAGE_SIZE + 1,
            sortType: sortField,
            order,
        });
    }, [
        loadPeople,
        props.lastKeyEngagementMaxDaysAgo,
        props.teamEngagement.teamId,
        props.registrationTerms,
        pageIndex,
        order,
        sortField,
    ]);
    return (_jsxs(_Fragment, { children: [_jsxs("tr", { children: [_jsxs("td", { children: [canSeeAllKeyEngagements && (_jsxs("button", { className: "btn btn-link text-dark mr-2", onClick: () => setIsExpanded((e) => !e), children: [_jsx(FAIcon, { icon: isExpanded ? "angle-up" : "angle-down", fixedWidth: true, size: "lg" }), _jsx("span", { className: "sr-only", children: isExpanded ? "Collapse" : "Expand" })] })), props.teamEngagement.teamName] }), _jsx("td", { className: "text-center", children: props.teamEngagement.caseloadSize }), _jsxs("td", { className: "text-right", style: { width: 130 }, children: [_jsx(ProgressBar, { bars: [
                                    {
                                        progress: 1 -
                                            props.teamEngagement.lastEngagementOlderThanMax /
                                                props.teamEngagement.caseloadSize,
                                        link: props.hasAccessToKeyEngagementsReport
                                            ? `/aviso/report/engagementReport?teamId=${props.teamEngagement.teamId}&lastKeyEngagementDateFrom=${getLastKeyEngagementDateFilter(props.lastKeyEngagementMaxDaysAgo)}&studentStatusId=1&runNow=1`
                                            : null,
                                        color: BootstrapColorService.Success,
                                        title: `${props.teamEngagement.caseloadSize -
                                            props.teamEngagement.lastEngagementOlderThanMax} student${props.teamEngagement.caseloadSize -
                                            props.teamEngagement.lastEngagementOlderThanMax ===
                                            1
                                            ? " has"
                                            : "s have"} had a key engagement in the last ${props.lastKeyEngagementMaxDaysAgo} day${props.lastKeyEngagementMaxDaysAgo === 1 ? "" : "s"}.`,
                                        linkIsNotToReactPage: true,
                                    },
                                    {
                                        progress: props.teamEngagement.lastEngagementOlderThanMax /
                                            props.teamEngagement.caseloadSize,
                                        link: props.hasAccessToKeyEngagementsReport
                                            ? `/aviso/report/engagementReport?teamId=${props.teamEngagement.teamId}&lastKeyEngagementDateFrom=${getLastKeyEngagementDateFilter(props.lastKeyEngagementMaxDaysAgo)}&studentStatusId=1&runNow=1`
                                            : null,
                                        title: `${props.teamEngagement.lastEngagementOlderThanMax} student${props.teamEngagement.lastEngagementOlderThanMax === 1
                                            ? " has"
                                            : "s have"} not had a key engagement in the last ${props.lastKeyEngagementMaxDaysAgo} day${props.lastKeyEngagementMaxDaysAgo === 1 ? "" : "s"}.`,
                                        color: BootstrapColorService.Danger,
                                        linkIsNotToReactPage: true,
                                    },
                                ] }), _jsx("div", { children: _jsxs("small", { className: "text-muted", children: [Math.round(100 -
                                            (100 * props.teamEngagement.lastEngagementOlderThanMax) /
                                                props.teamEngagement.caseloadSize), "%"] }) })] })] }), isExpanded && (_jsx("tr", { children: _jsxs("td", { colSpan: "3", children: [_jsx(Busy, { isBusy: people.isLoading }), _jsx(KeyEngagementAdvisorScore, { people: people, lastKeyEngagementMaxDaysAgo: 30, order: order, setOrder: setOrder, sortField: sortField, setSortField: setSortField, hasAccessToKeyEngagementsReport: true, hasPrevPage: hasPrevPage, hasNextPage: hasNextPage, prevPage: prevPage, nextPage: nextPage, pageSize: PAGE_SIZE, isNested: true })] }) }))] }));
};
export default KeyEngagementTeam;
